import React from 'react';
import { useParams } from 'react-router-dom';
import { PageWrapper } from '../../components/common';
import { EditarPadron } from '../../components/padron/EditarPadron';

const EditarPadronPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <PageWrapper>
        <div style={{ textAlign: 'center', padding: '40px' }}>
          Error: No se proporcionó ID
        </div>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <EditarPadron id={parseInt(id)} />
    </PageWrapper>
  );
};

export default EditarPadronPage;    